<template>
  <div id="branchLoyaltyConfig">
    <div class="container">
      <div class="page-title">
        {{ $t('loyalty.main_title') }}
      </div>

      <Tabs>
        <TabSection title="Configuration" v-if="$store.getters.loggedUserHasSuperAdmin">
          <template v-if="$store.getters.loggedUserHasSuperAdmin">
            <div class="group">
              <label>{{ $t('loyalty.type') }}</label>
              <select v-model="selected">
                <option :value="null">{{ $t('loyalty.none') }}</option>
                <option value="ishopfood">iShopFood</option>
                <!-- <option value="data_candy">Data Candy</option> -->
                <option value="free_bees">Free Bees</option>
              </select>
            </div>

            <div class="fidelity-program" v-show="isDataCandySelected">
              <div class="group">
                <label>Impersonated Merchant ID (IMI)</label>
                <input type="text" v-model="data_candy.data.imi">
              </div>
              <div class="group">
                <input id="candy_activated_chk" type="checkbox" v-model="data_candy.activated">
                <label for="candy_activated_chk">{{ $t('loyalty.activated') }}</label>
              </div>
            </div>

            <div class="fidelity-program" v-show="isFreeBeesSelected">
              <div class="group">
                <label>Partner ID</label>
                <input type="text" v-model="free_bees.data.partner_id">
              </div>
              <div class="group">
                <label>Location ID</label>
                <input type="text" v-model="free_bees.data.location_id">
              </div>
              <div class="group">
                <label>Security Key</label>
                <input type="text" v-model="free_bees.data.security_key">
              </div>
              <div class="group" v-show="selected !== null">
                <input id="free_activated_chk" type="checkbox" v-model="free_bees.activated">
                <label for="free_activated_chk">{{ $t('loyalty.activated') }}</label>
              </div>
            </div>

            <div class="fidelity-program" v-show="isiShopFoodSelected">
              <div class="group">
                <label>{{ $t('name') }}</label>
                <input type="text" v-model="ishopfood.data.name">
              </div>
              <div class="group">
                <label>{{ $t('description') }}</label>
                <textarea v-model="ishopfood.data.description" />
              </div>
              <div class="columns">
                <div class="column">
                  <div class="subtitle">{{ $t('loyalty.loyalty_settings') }}</div>
                  <div class="group">
                    <input id="ishopfood_activated_chk" type="checkbox" v-model="ishopfood.data.activated">
                    <label for="ishopfood_activated_chk">{{ $t('loyalty.activated') }}</label>
                  </div>
                  <div class="group">
                    <input id="ewallet_activated_chk" type="checkbox" v-model="ishopfood.data.eWalletActivated">
                    <label for="ewallet_activated_chk">{{ $t('loyalty.e_wallet_activated') }}</label>
                  </div>
                  <div class="group">
                    <input id="hub_launch_activated_chk" type="checkbox" v-model="ishopfood.data.launchAppWithHub">
                    <label for="hub_launch_activated_chk">{{ $t('loyalty.launch_hub') }}</label>
                  </div>
                  <div class="group">
                    <input id="mobile_only_activated_chk" type="checkbox"
                      v-model="ishopfood.data.activatedOnlyOnMobileApp">
                    <label for="mobile_only_activated_chk">{{ $t('loyalty.only_on_mobile_app') }}</label>
                  </div>
                  <div class="group">
                    <input id="apply_loyalty_payment_as_discount" type="checkbox"
                      v-model="ishopfood.data.applyLoyaltyPaymentOnSubtotal">
                    <label for="apply_loyalty_payment_as_discount">{{ $t('loyalty.applyLoyaltyPaymentOnSubtotal') }}</label>
                  </div>
                  <div class="group">
                    <input id="apply_loyalty_payment_automatically" type="checkbox"
                      v-model="ishopfood.data.applyLoyaltyPaymentAutomatically">
                    <label
                      for="apply_loyalty_payment_automatically">{{ $t('loyalty.apply_loyalty_payment_automatically') }}</label>
                  </div>
                  <div class="group">
                    <input id="chk_gift_card" type="checkbox" v-model="ishopfood.data.giftCardActivated">
                    <label for="chk_gift_card">{{ $t('loyalty.enable_gift_card') }}</label>
                  </div>
                </div>
                <div class="column" v-show="ishopfood.data.eWalletActivated">
                  <div class="subtitle">{{ $t('loyalty.eWallet_management') }}</div>
                  <div class="group">
                    <input id="rank_enabled_chk" type="checkbox" v-model="ishopfood.data.rankEnabled">
                    <label for="rank_enabled_chk">{{ $t('loyalty.enable_rank') }}</label>
                  </div>
                  <div class="group">
                    <input id="user_management_chk" type="checkbox" v-model="userManagement">
                    <label for="user_management_chk">{{ $t('loyalty.enable_user_management') }}</label>
                  </div>
                  <div class="group">
                    <input id="recharge_enabled_chk" type="checkbox" v-model="ishopfood.data.rechargeEnabled">
                    <label for="recharge_enabled_chk">{{ $t('loyalty.enable_recharge') }}</label>
                  </div>
                  <div class="group">
                    <input id="auto_recharge_enabled_chk" type="checkbox" v-model="ishopfood.data.autoRechargeEnabled">
                    <label for="auto_recharge_enabled_chk">{{ $t('loyalty.enable_auto_recharge') }}</label>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </TabSection>

        <TabSection class="levels" :title="$t('loyalty.level_configuration')"
          v-if="$store.getters.loggedUserHasSuperAdmin && isiShopFoodSelected && ishopfood.data.rankEnabled">
          <template v-if="$store.getters.loggedUserHasSuperAdmin"
            v-show="isiShopFoodSelected && ishopfood.data.rankEnabled">
            <div class="title">
              <span>{{ $t('loyalty.levels') }}</span>
              <button class="btn btn-primary" @click="addLevel">
                <svgicon src="/icon/add.svg" :height="14" :width="14"></svgicon>
              </button>
            </div>
            <div class="level" v-for="(level, levelIndex) of ishopfood.data.levels">
              <div class="title">
                <span>{{ ($t('loyalty.level') + ' #' + (levelIndex + 1)) }}</span>
                <button class="btn btn-primary" @click="removeLevel(levelIndex)">
                  <svgicon src="/icon/close.svg" :height="14" :width="14"></svgicon>
                </button>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="group">
                    <LocalizedInput :title="$t('loyalty.level_name')" :translate="level.name" />
                  </div>
                  <div class="group">
                    <LocalizedInput :title="$t('loyalty.level_description')" :translate="level.description" />
                  </div>
                  <div class="group">
                    <ImageUpload :identifier="'uploadImageLevel' + levelIndex" :object="level.icon" :previewHeight="120"
                      :maxSizeInMb="0.8" @changed="level.icon = $event" />
                  </div>
                </div>
                <div class="column">
                  <div class="group">
                    <label>{{ $t('loyalty.level_rate') }}</label>
                    <input type="number" v-model="level.rate">
                  </div>
                  <div class="group">
                    <label>{{ $t('loyalty.level_points') }}</label>
                    <input type="number" v-model="level.points">
                  </div>
                </div>
              </div>
            </div>
            <div class="no-content" v-if="ishopfood.data.levels && ishopfood.data.levels.length === 0">
              {{ $t('loyalty.no_level') }}
            </div>
          </template>
        </TabSection>

        <TabSection class="promotions" :title="$t('loyalty.promo_on_recharge')"
          v-if="isiShopFoodSelected && ishopfood.data.rechargeEnabled">
          <template>
            <div class="desc">{{ $t('loyalty.promo_on_recharge_description') }}</div>
            <div class="title">
              <span>{{ $t('loyalty.promotions') }}</span>
              <button class="btn btn-primary" @click="addPromotion">
                <svgicon src="/icon/add.svg" :height="14" :width="14"></svgicon>
              </button>
            </div>
            <div class="promotion" v-for="(promotion, promotionIndex) of ishopfood.data.promotions">
              <div class="promo-text">
                <span>{{ $t('loyalty.purchase_for') }}</span>
                <input v-model="promotion.minimum" type="number" step="0.01" min="0.01">
                <span>$ {{ $t('loyalty.and_gain') }}</span>
                <input v-model="promotion.rewardAmount" type="number" step="0.01" min="0.01">
                <select v-model="promotion.rewardType">
                  <option value="flat">$</option>
                  <option value="percent">%</option>
                </select>
                <span>{{ $t('loyalty.bonus') }}</span>
                <button class="btn btn-primary" @click="removePromotion(promotionIndex)">
                  <svgicon src="icon/close.svg" :height="14" :width="14"></svgicon>
                </button>
              </div>
            </div>
            <div class="no-content" v-if="ishopfood.data.promotions && ishopfood.data.promotions.length === 0">
              {{ $t('loyalty.no_promotion') }}
            </div>
          </template>
        </TabSection>

        <TabSection class="giftcard" :title="$t('loyalty.gift_card_configuration')"
          v-if="isiShopFoodSelected && ishopfood.data.giftCardActivated && ishopfood.data.giftCard">
          <template v-if="isiShopFoodSelected && ishopfood.data.giftCardActivated && ishopfood.data.giftCard">

            <Panel :title="$t('loyalty.terms')" collapsible>
              <div class="group">
                <LocalizedInput :title="$t('loyalty.gift_card_terms')" :translate="ishopfood.data.giftCard.terms"
                  textarea />
              </div>

              <div class="group">
                <LocalizedInput :title="$t('loyalty.gift_card_advanced_terms')"
                  :translate="ishopfood.data.giftCard.advancedTerms" textarea />
              </div>
            </Panel>

            <Panel class="panel-templates" :title="$t('loyalty.card_templates')" collapsible collapsed>
              <div class="title">
                <div class="text">{{ $t('loyalty.templates') }}</div>
                <button class="btn btn-primary" @click="addGiftCardTemplate">
                  <svgicon src="icon/add.svg" :height="14" :width="14"></svgicon>
                </button>
              </div>
              <div class="templates">
                <div class="template" v-for="(template, templateIndex) of templates" :key="'template-' + templateIndex">
                  <div class="template-header">
                    <span class="text">{{ $t('loyalty.template') }} #{{ templateIndex + 1 }}</span>
                    <button class="btn btn-primary" @click="deleteGiftCardTemplate(templateIndex)" v-if="!template.id">
                      <svgicon src="icon/close.svg" :height="14" :width="14"></svgicon>
                    </button>

                  </div>
                  <div class="group split">
                    <div class="input-holder">
                      <LocalizedInput :title="$t('loyalty.level_name')" :translate="template.name" />
                    </div>
                    <div class="checkbox-holder">
                      <input :id="'template_active' + templateIndex" type="checkbox" v-model="template.active">
                      <label :for="'template_active' + templateIndex">{{ $t('loyalty.template_active') }}</label>
                    </div>
                  </div>
                  <div class="group">
                    <ImageUpload :identifier="'updateImageTemplate' + templateIndex" :object="template.image"
                      @changed="template.image = $event" :maxSizeInMb="0.8" />
                  </div>
                </div>
              </div>
              <div class="empty" v-if="templates.length === 0">
                {{ $t('loyalty.template_empty') }}
              </div>
            </Panel>

            <Panel :title="$t('loyalty.activated_companies')" collapsible>
              <p>{{ $t('loyalty.activated_companies_description') }}</p>
              <ListMultiSelect :bank="companies" :bankTitle="$t('companies.title')" showSelectAll showUnselectAll
                :selected="ishopfood.data.giftCard.companies" :selectedTitle="$t('menuboard.selected_companies')" />
            </Panel>

          </template>
        </TabSection>
      </Tabs>

      <div class="footer-actions">
        <button class="btn btn-primary" @click="save">{{ $t('save') }}</button>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import LocalizedInput from '@/components/tools/LocalizedInput.vue';
import ListMultiSelect from "@/components/tools/ListMultiSelect.vue";
import ImageUpload from '@/components/tools/ImageUpload.vue';

export default {

  name: "BranchLoyaltyConfig",

  components: { LocalizedInput, ImageUpload, ListMultiSelect },

  data() {
    return {
      branchId: undefined,
      userManagement: false,
      selected: null,
      templates: [],
      companies: [],
      data_candy: {
        type: 'data_candy',
        activated: false,
        data: {
          imi: ''
        }
      },
      free_bees: {
        type: 'free_bees',
        activated: false,
        data: {
          partner_id: '',
          location_id: '',
          security_key: ''
        }
      },
      ishopfood: {
        type: 'ishopfood',
        data: {
          activated: false,
          eWalletActivated: false,
          launchAppWithHub: false,
          rankEnabled: false,
          rechargeEnabled: false,
          autoRechargeEnabled: false,
          giftCardActivated: false,
          activatedOnlyOnMobileApp: false,
          applyLoyaltyPaymentOnSubtotal: false,
          applyLoyaltyPaymentAutomatically: false,
          giftCard: {
            terms: { fr: "", en: "" },
            advancedTerms: { fr: "", en: "" },
            taxPaidInAdvance: false,
            companies: []
          },
          levels: [],
          promotions: [],
          name: '',
          description: ''
        }
      }
    }
  },

  computed: {
    isDataCandySelected() {
      return this.selected === 'data_candy'
    },
    isFreeBeesSelected() {
      return this.selected === 'free_bees'
    },
    isiShopFoodSelected() {
      return this.selected === 'ishopfood'
    }
  },

  async mounted() {
    this.branchId = this.$route.query.branch;
    this.$store.state.pageTitleTranslationKey = "loyalty.title";
    this.$store.state.pageIcon = "/icon/loyalty.svg";

    showSpinner();
    let [response, templateResponse, companiesResponse] = await Promise.all([
      this.getBranch({ branchId: this.branchId, augment: 'loyalty' }),
      this.getBranchGiftCardTemplates(({ branchId: this.branchId })),
      this.getCompanies(this.branchId)
    ]);
    hideSpinner();

    if (templateResponse) {
      this.templates = templateResponse.data;
    }

    if (companiesResponse) {
      this.companies = companiesResponse.map(c => ({
        name: c.name,
        id: c.id
      }));
    }

    if (response) {
      this.setFormDataFromResponse(response);
    } else {
      toast(this.$t("error.no_server"), "error");
    }
  },

  methods: {
    ...mapActions(['getBranch', 'saveBranch', 'getBranchGiftCardTemplates', 'saveGiftCardTemplate', 'createBranchGiftCardTemplate', 'getCompanies']),

    async save() {
      let data = {
        loyaltyConfig: this.selected ? JSON.parse(JSON.stringify(this[this.selected])) : null,
        userManagement: this.userManagement
      };
      this.formatPromotions(data);
      this.formatGiftCardData(data);
      this.formatImagesBeforeSave(data);

      showSpinner();
      let response = await this.saveBranch({ branchId: this.branchId, augment: 'loyalty', data });
      await this.saveGiftCardTemplates();
      hideSpinner();

      if (response) {
        this.setFormDataFromResponse(response);
        showSpinner();
        if (this.templates.length > 0) {
          let templateResponse = await this.getBranchGiftCardTemplates(({ branchId: this.branchId }));
          if (templateResponse) {
            this.templates = templateResponse.data;
          }
        }
        hideSpinner();
        toast(this.$t("branch.success"), "success");
      } else {
        toast(this.$t("error.no_server"), "error");
      }
    },

    async saveGiftCardTemplates() {
      for (let template of this.templates) {
        let data = JSON.parse(JSON.stringify(template));
        data.image = getImageData(data.image);
        let response;
        if (template.id) {
          response = await this.saveGiftCardTemplate({ templateId: template.id, data: data });
        } else {
          response = await this.createBranchGiftCardTemplate({ data: data });
        }
      }
    },

    setFormDataFromResponse(response) {
      if (response.loyaltyConfig === undefined) {
        toast(this.$t('loyalty.not_configured'), 'warning')
      }
      if (response.userManagement) {
        this.userManagement = response.userManagement;
      }
      if (response.loyaltyConfig && response.loyaltyConfig.type) {
        this.selected = response.loyaltyConfig.type;
        Object.assign(this[response.loyaltyConfig.type], response.loyaltyConfig);
      }
      if (this.isiShopFoodSelected && this.ishopfood.data.giftCardActivated) {
        if (!this.ishopfood.data.giftCard) {
          this.ishopfood.data.giftCard = {
            terms: { fr: "", en: "" },
            advancedTerms: { fr: "", en: "" },
            taxPaidInAdvance: false,
            companies: []
          };
        }
        if (!this.ishopfood.data.giftCard.companies) {
          this.ishopfood.data.giftCard.companies = [];
        } else {
          let companies = [];
          for (let company of this.ishopfood.data.giftCard.companies) {
            let foundCompany = this.companies.find(c => c.id === company);
            if (foundCompany) {
              companies.push(foundCompany);
            }
          }
          this.ishopfood.data.giftCard.companies = companies;
        }
      }
    },

    formatGiftCardData(data) {
      if (data.loyaltyConfig && data.loyaltyConfig.data && data.loyaltyConfig.data.giftCard && data.loyaltyConfig.data.giftCard.companies) {
        data.loyaltyConfig.data.giftCard.companies = data.loyaltyConfig.data.giftCard.companies.map(c => c.id)
      }
    },

    formatPromotions(data) {
      if (data.loyaltyConfig && data.loyaltyConfig.data.promotions) {
        for (let promotion of data.loyaltyConfig.data.promotions) {
          promotion.minimum = parseFloat(promotion.minimum);
          promotion.rewardAmount = parseFloat(promotion.rewardAmount);
        }
      }
    },

    formatImagesBeforeSave(data) {
      if (data.loyaltyConfig && data.loyaltyConfig.data.levels) {
        for (let level of data.loyaltyConfig.data.levels) {
          level.icon = getImageData(level.icon);
        }
      }
    },

    addLevel() {
      this.ishopfood.data.levels.push({
        name: { fr: "", en: "" },
        description: { fr: "", en: "" },
        icon: { url: "" },
        points: null,
        rate: null
      });
    },

    addPromotion() {
      this.ishopfood.data.promotions.push({
        rewardType: "percent",
        minimum: 200,
        rewardAmount: 20
      })
    },

    addGiftCardTemplate() {
      this.templates.push({
        branch: this.branchId,
        name: { fr: "", en: "" },
        image: null,
        active: true
      });
    },

    deleteGiftCardTemplate(index) {
      this.templates.splice(index, 1);
    },

    removePromotion(index) {
      this.ishopfood.data.promotions.splice(index, 1);
    },

    removeLevel(index) {
      this.ishopfood.data.levels.splice(index, 1);
    }
  }
}
</script>

<style lang="scss" scoped>
#branchLoyaltyConfig {
  display: flex;
  flex-direction: column;
}

.fidelity-program {
  margin-bottom: 40px;
}

.btn.btn-primary .svgicon {
  fill: white;

  &:last-child {
    margin-right: 0;
  }
}

.panel .subtitle {
  margin-top: 20px;
  text-transform: none;
  padding-bottom: 4px;
  border-bottom: 1px solid rgba(252, 102, 80, 0.55);
}

.levels,
.promotions {
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    fill: white;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    margin-bottom: 10px;
    font-weight: bold;
    font-size: 18px;
  }

  button {
    padding: 12px;
  }

  .promotion,
  .level {
    &:not(:last-child) {
      border-bottom: 1px dashed #ddd;
      padding-bottom: 10px;
      margin-bottom: 10px;
    }

    .title {
      border-bottom: none;
      font-size: 16px;
      margin-bottom: 0;
    }
  }
}

.promo-text {
  min-height: 38px;

  input,
  select {
    width: 90px;
    padding: 4px 0;
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 0;
    font-weight: bold;
    margin-left: 10px;

    &:focus,
    &:active {
      border-color: rgba(252, 102, 80, 0.55);
    }
  }

  select {
    width: 40px;
  }

  .btn {
    float: right;
    fill: white;
  }
}

.group.split {
  display: flex;
  flex-direction: row;
  width: 100%;

  .input-holder {
    flex-grow: 1;
    margin-right: 20px;
  }

  .checkbox-holder {
    margin-top: 25px;
    display: flex;
    align-items: center;
  }
}

.desc {
  margin-bottom: 15px;
}

.no-content {
  color: #888;
  padding-top: 20px;
  font-size: 14px;
}

.panel-templates {
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 15px;
    border-bottom: 1px solid #ddd;

    .text {
      font-weight: bold;
      font-size: 18px;
    }
  }

  .template {
    padding-top: 30px;

    &:not(:last-child) {
      border-bottom: 1px dashed #ddd;
      padding-bottom: 15px;
    }

    .template-header {
      font-weight: bold;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
    }
  }

  .empty {
    font-style: italic;
    padding-top: 30px;
  }
}</style>
